import * as React from "react";
import {
    Accordion,
    AccordionHeader,
    AccordionItem,
    AccordionPanel,
    Label,
    makeStyles,
    Textarea,
    useId
} from "@fluentui/react-components";
import { flexColumn, formInputStyle, growFlexColumn } from "../styles/GlobalStyles";

const useStyles = makeStyles({
    formInput: formInputStyle,
    preWrap: {
        whiteSpace: "pre-wrap"
    },
    flexColumn: flexColumn,
    growFlexColumn: growFlexColumn,
    container: {
        ...growFlexColumn,
        minWidth: "200px"
    }
});

export interface LicenseExplorerProps
{
    licenseBase64: string;
}

export const LicenseExplorer: React.FC<LicenseExplorerProps> = (props) => {
    const styles = useStyles();

    const headerId = useId("license_header");
    const claimsId = useId("license_claims");
    const signatureId = useId("license_signature");

    const [encodedHeaders, encodedClaims, signature] =  React.useMemo(() =>
    {
        return props.licenseBase64.split('.');
    }, [ props.licenseBase64 ] );

    const plainHeaders = React.useMemo( () => atob( encodedHeaders ), [ encodedHeaders ] );
    const plainClaims = React.useMemo( () => atob( encodedClaims ), [ encodedClaims ] );

    const formattedHeaders = React.useMemo( () => JSON.stringify(JSON.parse( plainHeaders ), undefined, 4 ), [ plainHeaders ] );
    const formattedClaims = React.useMemo( () => JSON.stringify(JSON.parse( plainClaims ), undefined, 4 ), [ plainClaims ] );

    return (
        <div className={styles.container}>
            <Accordion collapsible>
                <AccordionItem value="1">
                    <AccordionHeader>License Explorer</AccordionHeader>
                    <AccordionPanel>
                        <div className={styles.growFlexColumn}>
                            <div className={styles.formInput}>
                                <Label htmlFor={headerId} size="medium">
                                    License Header
                                </Label>
                                <Textarea textarea={{ style: { minHeight: "120px" } }} aria-labelledby={headerId} className={styles.preWrap} defaultValue={ formattedHeaders } style={{ flex: 1 }} disabled></Textarea>
                            </div>
                            <div className={styles.formInput}>
                                <Label htmlFor={claimsId} size="medium">
                                    Claims
                                </Label>
                                <Textarea textarea={{ style: { minHeight: "300px" } }} aria-labelledby={claimsId} className={styles.preWrap} defaultValue={formattedClaims} style={{ flex: 1 }} disabled></Textarea>
                            </div>
                            <div className={styles.formInput}>
                                <Label htmlFor={signatureId} size="medium">
                                    Signature
                                </Label>
                                <Textarea textarea={{ style: { minHeight: "120px" } }} aria-labelledby={signatureId} className={styles.preWrap} defaultValue={signature} style={{ flex: 1 }} disabled></Textarea>
                            </div>
                        </div>
                    </AccordionPanel>
                </AccordionItem>
            </Accordion>
        </div>
    );
};